<template>
    <form @submit.prevent="onSubmit">
        <div class="hero__top">
            <div class="hero__header">Turkode</div>
        </div>
        <div class="hero__code">
            <input
                v-for="(box, index) in 4"
                :key="index"
                :ref="el => setBoxRef(el, index)"
                v-model="values[index]"
                :type="index < 2 ? 'text' : 'number'"
                maxlength="1"
                class="codebox"
                :pattern="index < 2 ? '[A-Za-zÆØÅæøå]' : undefined"
                :disabled="loading"
                @keyup="onKeyup($event, index)"
            >
        </div>
        <input type="submit" class="hero__action hero__action--link" value="Registrer" :disabled="loading">
    </form>
</template>

<script setup>
import { reactive } from 'vue';

const props = defineProps({
    loading: { type: Boolean, default: false },
});
const emit = defineEmits(['submit-code']);

const values = reactive(['', '', '', '']);

// Plain array, not a ref - these are DOM element handles, not reactive state.
const boxes = [];

function setBoxRef(el, index) {
    if (el) {
        boxes[index] = el;
    }
}

// Mirrors app/js/stikkut.js's onCodeChange() (used by the legacy codeform.twig
// on the frontpage) - maxlength is ignored on type="number" inputs, so the
// truncation to 1 char has to be done manually here too, not just via the
// maxlength attribute.
function onKeyup(e, index) {
    const goBack = e.key === 'Backspace' || e.key === 'ArrowLeft';
    const goForward = e.key === 'ArrowRight';
    // v-model casts to a real Number for the type="number" boxes (Vue does
    // this for any input whose resolved type is "number", not just when the
    // .number modifier is used) - .length on a Number is undefined, which
    // silently broke the auto-advance below for those two boxes.
    const val = String(values[index] ?? '');

    const next = boxes[index + 1];
    if (next) {
        if (goForward || val.length >= 1) {
            if (val.length > 1) {
                values[index] = val.slice(0, 1);
            }
            next.focus();
            return;
        }
    } else if (val.length >= 1) {
        values[index] = val.slice(0, 1);
        return;
    }

    const prev = boxes[index - 1];
    if (prev && goBack) {
        prev.focus();
    }
}

function onSubmit() {
    if (props.loading) {
        return;
    }
    emit('submit-code', values.join(''));
}

defineExpose({
    clear() {
        values.forEach((_, i) => { values[i] = ''; });
        boxes[0]?.focus();
    },
});
</script>
